// extracted by mini-css-extract-plugin
export default {"parentBox":"confirmPopup_parentBox__12UIS","childBox":"confirmPopup_childBox__ubvdQ","closeUpIcon":"confirmPopup_closeUpIcon__-su1f","popupText":"confirmPopup_popupText__G5MP0"};